<template>
  <b-modal
    v-model="activeModal"
    has-modal-card
    :width="640"
    :can-cancel="['escape', 'outside']"
    scroll="keep"
    @close="$emit('close')"
  >
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ $t('admin.product.additionalResources.title') }}
        </p>
        <button
          type="button"
          class="delete"
          @click="$emit('close')"
        />
      </header>
      <section class="modal-card-body p-t-20 p-b-20">
        <div class="container">
          <template v-if="product?.filePivots?.length>0">
            <h5 class="title is-5">
              {{ $t('admin.product.additionalResources.sectionOne.title') }}
            </h5>
            <p>
              {{ $t('admin.product.additionalResources.sectionOne.content') }}
            </p>
            <div class="my-5">
              <gallery :images="product.filePivots" without-main-photo />
            </div>
          </template>
          <div v-if="product?.data1">
            <h5 class="title is-5">
              {{ $t('admin.product.additionalResources.sectionTwo.title') }}
            </h5>
            <p class="mb-3">
              {{ $t('admin.product.additionalResources.sectionTwo.content') }}
            </p>
            <div style="white-space: pre-wrap;" v-html="product.data1" />
          </div>
          <div v-if="product?.data2" class="mt-5">
            <h5 class="title is-5">
              {{ $t('admin.product.additionalResources.sectionThree.title') }}
            </h5>
            <p class="mb-3">
              {{ $t('admin.product.additionalResources.sectionThree.content') }}
            </p>
            <div style="white-space: pre-wrap;" v-html="product.data2" />
          </div>
        </div>
      </section>
    </div>
  </b-modal>
</template>

<script>
import bbcodeHTML from '~/marketplace-front-core/config/bbcodeHTML'
import gallery from '~/marketplace-front-core/components/gallery/ZoomGallery'

export default {
  components: {
    gallery
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      activeModal: false
    }
  },
  watch: {
    active (newValue) {
      this.activeModal = newValue
    }
  },
  methods: {
    // close () {
    //   this.$emit('close')
    // },
    generate (content, type) {
      return bbcodeHTML(content, type)
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-card-title{
  flex-shrink: 1;
}
</style>
